// extracted by mini-css-extract-plugin
module.exports = {"dialogDetail":"JobAlertDialogText_dialogDetail__JhsdA","dialogButton":"JobAlertDialogText_dialogButton__nBNU3"};